import { useMemo } from 'react';
import { Text } from "../../../atoms";
import { useDropzoneContext } from "../Dropzone";
import { DropzoneFilenameProps } from "../Dropzone.types";

const DropzoneFilename = ({ children, fileIndex = 0, ...props }: DropzoneFilenameProps) => {
  const { files, metadata } = useDropzoneContext();
  const fileName = useMemo(() => {
    // Try metadata first (works for URL mode with loaded/uploaded URLs)
    if (metadata && metadata.length > fileIndex && metadata[fileIndex]) {
      return metadata[fileIndex].filename;
    }

    // Fallback to File object (works for fresh uploads and File mode)
    if (files.length > fileIndex && files[fileIndex]) {
      return files[fileIndex].name;
    }

    return '';
  }, [files, metadata, fileIndex]);
  return <Text {...props}>{fileName}</Text>;
};

export default DropzoneFilename;
